/**
 * public/index.html carries generic meta tags (marked data-seo-fallback) for
 * crawlers that don't run JavaScript. Once the app runs, each page sets its own
 * tags through <Seo>, and react-helmet doesn't remove tags it didn't create, so
 * drop the fallbacks to avoid two descriptions and two sets of social tags.
 * The <title> element stays: react-helmet updates its text.
 */
export function removeFallbackTags(doc = document) {
  doc.querySelectorAll("[data-seo-fallback]").forEach((el) => {
    if (el.tagName === "TITLE") el.removeAttribute("data-seo-fallback");
    else el.remove();
  });
}
